import React, { useState, useEffect } from 'react';
import { toAbsoluteUrl } from './AssetHelpers';
import { useAuth } from '../../app/modules/auth';
interface AccordionItemProps {
    id: number;
    title: string;
    country: string;
    processedBetween: string;
    imageSrc: string;
    organization: string;
    description: string;
    certifications: string;
    expandedAccordion: number | null;
    onToggle: (id: number) => void;
}
interface DdpCProps {
    user: any;
}
interface ProgressBarProps {
    label: string;
    percentage: number;
    colorClass: string;
}

const DdpC: React.FC<DdpCProps> = ({ user }) => {


    console.log("user in ddp is ", user)


    const [expandedSection, setExpandedSection] = useState<string>('details');
    const [expandedAccordion, setExpandedAccordion] = useState<number | null>(null);
    const [activeTab, setActiveTab] = useState<string>('description');
    const [mainImage, setMainImage] = useState(user.productImages?.[0]?.url || '');

    // const [mainImage2, setMainImage2] = useState<string>('/sibig.jpg');
    const [progressValues, setProgressValues] = useState({
        co2: 70,
        water: 50,
        waste: 30
    });

    const [mainImage2, setMainImage2] = useState<string>(user?.socialImpact?.[0]?.url || '/sibig.jpg');

    useEffect(() => {
        // Animate progress bars on component mount
        const timer = setTimeout(() => {
            setProgressValues({ co2: 70, water: 50, waste: 30 });
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    // const toggleSection = (section: string) => {
    //     setExpandedSection(expandedSection === section ? '' : section);
    // };



    const toggleSection = (section: string) => {
        const newSection = expandedSection === section ? '' : section;
        setExpandedSection(newSection);

        // Auto-open first accordion when Material Traceability is opened
        if (section === 'traceability' && newSection === 'traceability') {
            setExpandedAccordion(1);
        } else if (newSection === '') {
            setExpandedAccordion(null);
        }
    };


    const toggleAccordion = (id: number) => {
        setExpandedAccordion(expandedAccordion === id ? null : id);
    };

    const toggleContent = (contentId: string) => {
        setActiveTab(contentId);
    };

    const changeImage = (src: string) => {
        setMainImage(src);
    };

    const changeImage2 = (src: string) => {
        setMainImage2(src);
    };

    const AccordionItem: React.FC<AccordionItemProps> = ({
        id,
        title,
        country,
        processedBetween,
        imageSrc,
        organization,
        description,
        certifications,
        expandedAccordion,
        onToggle
    }) => {
        const isExpanded = expandedAccordion === id;

        return (
            <div className="flex gap-3 mt-4 mb-3">
                {/* <div className="">
                    <div style={{ backgroundColor: '#0a79ac' }} className="w-10 h-10 p-2 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            className="text-white">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    </div>
                </div> */}

                <div className="bg-white rounded-lg shadow-lg flex-1">
                    <div className="p-4 cursor-pointer" onClick={() => onToggle(id)}>
                        <div className="flex justify-between items-center mb-4">
                            <div className="text-base font-bold mb-1">{title}</div>
                            <svg
                                className={`w-5 h-5 text-gray-500 transition-transform transform ${isExpanded ? 'rotate-180' : ''}`}
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                            </svg>
                        </div>
                        <div>
                            <div className="flex justify-between items-center">
                                <p className="font-medium text-sm">Country</p>
                                <p className=" text-sm">{country}</p>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-medium text-sm">Facility:</p>
                                <p className="text-sm">{processedBetween}</p>
                            </div>
                        </div>

                        <div className={`transition-all duration-300 overflow-hidden ${isExpanded ? 'max-h-screen' : 'max-h-0'}`}>
                            <hr className="w-full my-3" />
                            {/* <img className="rounded-lg mb-4 h-56 bg-gray-200 w-full object-cover" src={imageSrc} alt={title} />
                             */}



                            <img className="rounded-lg mb-4 bg-gray-200 w-full object-cover" style={{ height: 'auto' }} src={imageSrc} alt={title} />


                            <p className="text-base font-bold mb-1">Organization</p>
                            <div className="text-sm mb-4 ">{organization}</div>
                            <div className="text-sm ">{description}</div>
                            <div className="flex justify-between items-center pt-2">
                                <p className="text-base font-bold mb-1">Certifications:</p>
                                <p className=" text-sm">{certifications}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const ProgressBar: React.FC<ProgressBarProps> = ({ label, percentage, colorClass }) => (
        <div className="my-5">
            <label className="block mb-1 text-left text-sm font-medium">{label}</label>
            <div className="flex items-center justify-between">
                <div className="bg-gray-200 rounded-full overflow-hidden h-4 w-4/5">
                    <div
                        className={`h-full rounded-full transition-all duration-1000 ease-out ${colorClass}`}
                        style={{ width: `${percentage}%` }}
                    ></div>
                </div>
                <span className="block mt-0 font-bold text-sm">{percentage}%</span>
            </div>
        </div>
    );

    // const traceabilityData = [
    //     {
    //         id: 1,
    //         title: "Material Collection",
    //         country: "Morocco",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/material collection.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 2,
    //         title: "Material Processing",
    //         country: "Morocco",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/material processing.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 3,
    //         title: "Flake Manufacturing",
    //         country: "Spain",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/flake .jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 4,
    //         title: "Chip Manufacturing",
    //         country: "Turkey",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/chip_production.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 5,
    //         title: "Yarn Manufacturing",
    //         country: "France",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/Yarn.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 6,
    //         title: "Fabric Manufacturing",
    //         country: "France",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/texttile_production.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     },
    //     {
    //         id: 7,
    //         title: "Product Manufacturing",
    //         country: "Morocco",
    //         processedBetween: "23/02/2024-01/03/2024",
    //         imageSrc: "/product_menufacturing.jpg",
    //         organization: "MIKA",
    //         description: "MIKA is a social enterprise that has set itself the goal to collect orphan waste on the beaches of the Moroccan coastline, while providing fair work conditions and salaries above the minimum local average.",
    //         certifications: "GRS"
    //     }
    // ];



    const traceabilityData = user?.processes?.map((process, index) => ({
        id: index + 1,
        title: process.processName,
        country: process.country,
        processedBetween: process.facilityName, // You can modify this based on your data
        imageSrc: process.image,
        organization: process.facilityName,
        description: `${process.facilityName} located at ${process.address}`,
        certifications: process.certifications,
    })) || [];

    const { currentUser, auth, isFacilityManager, isSupplyChainManager }: any = useAuth()

    const image = isSupplyChainManager
        ? auth?.data?.profileImage || ''
        : isFacilityManager
            ? toAbsoluteUrl('/media/avatars/facMan.jpeg')
            : isSupplyChainManager
                ? currentUser?.franchiseKycDoc?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl
                : currentUser?.kycDocument?.filter((x) => x?.docType === 'SEC_DTI')?.[0]?.docUrl ||
                currentUser?.kycDocument?.filter((x) => x?.docType === 'CLIENT_LOGO')?.[0]?.docUrl


    return (
        // <div className="bg-gray-50 min-h-screen font-sans" style={{ color: '#333' }}>
        <div className="bg-gray-50 min-h-screen" style={{ color: '#333', fontFamily: 'Inter, Arial, sans-serif', marginTop: "-40px" }}>
            <div style={{ backgroundColor: 'white', height: '80px', width: '100%' }}></div>
            {/* max-w-md */}
            <div className="px-4  mx-auto" style={{ position: 'relative', zIndex: 10, marginTop: '-40px' }}>
                <div className="relative">
                    {/* Product Details Section */}
                    <div className="bg-white shadow-lg rounded-lg relative z-10 mb-2 mt-5">
                        <div className="p-1 cursor-pointer" onClick={() => toggleSection('details')}>
                            <div className="flex justify-between items-center mb-4">
                                {/* <img src="/logo.jpg" alt="Logo" className="h-11" /> */}
                                <img className="h-12 rounded" src={image || toAbsoluteUrl('/media/avatars/profile.jpeg')} alt='' />
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'details' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>

                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'details' ? 'block' : 'hidden'}`}>
                            <div className="p-2">
                                <p className="mb-2 text-sm">

                                    {/* At Rive Droite, we thrive to positively impact our environment and the lives of who we collaborate with. Following our unshakable purpose, we have decided to share as much information we have related to our activity. */}


                                    {user.description}

                                </p>
                                <hr className="border-t-2 border-gray-300" />
                                <h1 className="text-md font-bold mb-2 pt-2 text-sm">

                                    {user.productName}

                                </h1>
                                <hr className="border-t-2 border-gray-300 p-2 mt-2" />

                                {/* <div className="text-center">
                                    <div className="flex justify-center">
                                        <img src={mainImage} alt="Main Image" className="w-4/5 h-auto rounded-lg" />
                                    </div>
                                    <div className="flex justify-center mt-5">
                                        <img src="/s2.jpg" alt="Thumbnail 1" className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={() => changeImage('/s2.jpg')} />
                                        <img src="/s3.jpg" alt="Thumbnail 2" className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={() => changeImage('/s3.jpg')} />
                                        <img src="/s4.jpg" alt="Thumbnail 3" className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={() => changeImage('/s4.jpg')} />
                                    </div>
                                </div> */}


                                <div className="text-center">
                                    <div className="flex justify-center">
                                        <img
                                            src={mainImage}
                                            alt="Main Image"
                                            className="w-4/5 h-auto rounded-lg"
                                        />
                                    </div>

                                    <div className="flex justify-center mt-5">
                                        {user.productImages.slice(1).map((img, index) => (
                                            <img
                                                key={index}
                                                src={img.url}
                                                alt={`Thumbnail ${index + 1}`}
                                                className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform"
                                                onClick={() => changeImage(img.url)}
                                            />
                                        ))}
                                    </div>
                                </div>





                                <div className="flex justify-between items-center mt-4">
                                    <p style={{ background: '#12B886' }} className="text-white w-24 text-center py-1 mb-1 rounded text-xs">Best Seller</p>
                                    <p className="text-sm"></p>
                                </div>

                                <div className="my-1">
                                    <div className="flex justify-between items-center px-0">
                                        <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'description' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('description')}>Description</p>
                                        <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'practical-info' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('practical-info')}>Practical Information</p>
                                        <p className={`text-sm cursor-pointer mx-2 ${activeTab === 'our-mission' ? 'border-b-2 border-green-500' : ''}`} onClick={() => toggleContent('our-mission')}>
                                            Specification
                                        </p>
                                    </div>

                                    {activeTab === 'description' && (
                                        <div className="p-2 border border-blue-200 rounded mt-2">
                                            <p className="text-sm">{user.aboutBrand}</p>
                                        </div>
                                    )}

                                    {activeTab === 'practical-info' && (
                                        <div className="p-2 border border-blue-200 rounded mt-2">
                                            <div className="text-sm">
                                                {user.aboutItem}
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'our-mission' && (
                                        <div className="p-2 border border-blue-200 rounded mt-2">
                                            <p className="text-sm">

                                                <div className="space-y-3">
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Material</span>
                                                        <span className="text-sm">{user.categoryName}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Plastics</span>
                                                        <span className="text-sm ">{user.itemName}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Product</span>
                                                        <span className="text-sm ">{user.productName}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Dimension</span>
                                                        <span className="text-sm ">{user.dimension}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Weight</span>
                                                        <span className="text-sm ">{user.weight}</span>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <span className="font-semibold text-sm">Packaging</span>
                                                        <span className="text-sm ">-</span>
                                                    </div>
                                                </div>

                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Material Traceability Section */}
                    <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5">
                        <div className="p-2 cursor-pointer" onClick={() => toggleSection('traceability')}>
                            <div className="flex justify-between items-center mb-4">
                                {/* <h1 className="text-base mb-1" style={{ fontSize: '20px' }}>Material Traceability</h1> */}
                                <div className="text-base mb-1" style={{ fontSize: '20px' }}>Material Traceability</div>
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'traceability' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>

                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'traceability' ? 'block' : 'hidden'}`}>
                            <div className="p-4">
                                {traceabilityData.map((item) => (
                                    <AccordionItem
                                        key={item.id}
                                        {...item}
                                        expandedAccordion={expandedAccordion}
                                        onToggle={toggleAccordion}
                                    />
                                ))}
                            </div>
                        </div>


                    </div>

                    {/* Other Components Section */}
                    {/* <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5">
                        <div className="p-2 cursor-pointer" onClick={() => toggleSection('components')}>
                            <div className="flex justify-between items-center mb-4">
                                <div className="text-base mb-1" style={{ fontSize: '20px' }}>Other Components</div>
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'components' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>
                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'components' ? 'block' : 'hidden'}`} style={{ marginTop: '-30px' }}>
                            <div className="p-4 bg-white rounded-lg relative z-10 mb-1 mt-5">
                              
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px',
                                    marginBottom: '5px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'white'
                                }}>
                                    <div style={{ flexShrink: 0, marginLeft: '25px', marginRight: '15px' }}>
                                        <img src="/liner.svg" alt="" style={{ height: '20px', width: 'auto' }} />
                                    </div>
                                    <div style={{ flex: 1, textAlign: 'start' }}>
                                        <p className="text-sm text-gray-500">Liner: Made from 100% recycled PET, Morocco</p>
                                    </div>
                                </div>

                              
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px',
                                    marginBottom: '5px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'white'
                                }}>
                                    <div style={{ flexShrink: 0, marginLeft: '25px', marginRight: '15px' }}>
                                        <img src="/packaging.svg" alt="" style={{ height: '20px', width: 'auto' }} />
                                    </div>
                                    <div style={{ flex: 1, textAlign: 'start' }}>
                                        <p className="text-sm text-gray-500">Packaging: Made from recycled paper, Turkey</p>
                                    </div>
                                </div>

                             
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'white'
                                }}>
                                    <div style={{ flexShrink: 0, marginLeft: '25px', marginRight: '15px' }}>
                                        <img src="/zipper.svg" alt="" style={{ height: '20px', width: 'auto' }} />
                                    </div>
                                    <div style={{ flex: 1, textAlign: 'start' }}>
                                        <p className="text-sm text-gray-500">Zipper: Made from recycled steel, Italy</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* Impact Section */}
                    <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5 text-center">
                        <div className="p-2 cursor-pointer" onClick={() => toggleSection('impact')}>
                            <div className="flex justify-between items-center mb-4">
                                <div className="text-base mb-1 text-center" style={{ fontSize: '20px' }}>Impact</div>
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'impact' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>










                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'impact' ? 'block' : 'hidden'}`}>


                            <div className="grid grid-cols-2 gap-3 mb-4">
                                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                                        <img src="/media/svg/dashboard/GHG_saving.png" alt="GHG" className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700">GHG Savings</p>
                                        <p className="text-sm font-bold">{user?.co2Savings || 0}%</p>
                                    </div>
                                </div>

                                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                                        <img src="/media/svg/dashboard/energy_saved.png" alt="Energy" className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700">Energy Saved</p>
                                        <p className="text-sm font-bold">{user?.energySavings || 0}%</p>
                                    </div>
                                </div>

                                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
                                        <img src="/media/svg/dashboard/waste_saved.png" alt="Waste" className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700">Waste Saved</p>
                                        <p className="text-sm font-bold">{user?.waterSavings || 0}%</p>
                                    </div>
                                </div>

                                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                                    <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                                        <img src="/media/svg/dashboard/trees_saved.png" alt="Trees" className="w-6 h-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700">Trees Saved</p>
                                        <p className="text-sm font-bold">{user?.treeSavings || 0}</p>
                                    </div>
                                </div>
                            </div>




                            {/* <div className="max-w-lg mx-auto p-5">
                                <ProgressBar label="CO2 Reduction" percentage={progressValues.co2} colorClass="bg-green-500" />
                                <ProgressBar label="Water Footprint Reduction" percentage={progressValues.water} colorClass="bg-blue-500" />
                                <ProgressBar label="Waste Reduction" percentage={progressValues.waste} colorClass="bg-red-400" />
                            </div> */}



                            <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-1">
                                <hr className="border-t-2 border-gray-300 mb-2" />
                                <div className="text-base font-bold mb-1">Social Impact</div>
                                <hr className="border-t-2 border-gray-300 p-2 mt-2" />

                                {/* <div className="flex justify-around">
                                    <p className="text-sm p-2 border border-blue-200 rounded mt-2 w-2/5">Waste Picker Engaged<br />24</p>
                                    <p className="text-sm p-2 border border-blue-200 rounded mt-2 w-2/5">Economic Value Created<br />1,321 USD</p>
                                </div> */}

                                <div className="text-center">
                                    <div className="flex justify-center mt-5 mb-5">
                                        {user?.socialImpact?.map((impact, index) => (
                                            <img
                                                key={index}
                                                src={impact.url}
                                                alt={`Social Impact ${index + 1}`}
                                                className="w-24 h-auto mx-2 rounded-lg cursor-pointer hover:scale-105 transition-transform"
                                                onClick={() => changeImage2(impact.url)}
                                            />
                                        ))}
                                    </div>
                                    {/* <div className="flex justify-center pb-2">
                                        <img src={mainImage2} alt="Main Image" className="w-3/4 h-auto rounded-lg" />
                                    </div> */}
                                    <div className="pb-2 px-4">
                                        <img src={mainImage2} alt="Main Image" className="w-full h-auto rounded-lg" />
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>

                    {/* Care Instructions */}
                    {/* <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
                        <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
                            <div className="p-4">
                                <p className="text-sm text-gray-500 mb-4">To extend the life of our products, please consider the following options:</p>
                                <ul className="text-left space-y-2">
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        <span className="text-sm">Think about repairing or customizing it</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        <span className="text-sm">Donate it to an association in need or to a loved one</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        <span className="text-sm">Consider selling it on a second-hand platform</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        <span className="text-sm">Drop it off at a textile collection point</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> */}




                    {/* <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
                        <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
                            <div className="p-4">

                            </div>
                        </div>
                    </div> */}





                    {/* <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5 text-center">
                        <div className="p-2 cursor-pointer" onClick={() => toggleSection('End of Life')}>

            
                            <div className="flex justify-between items-center mb-4">
                                <div className="text-base mb-1 text-center" style={{ fontSize: '20px' }}>End of Life</div>
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'End of Life' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>

                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'End of Life' ? 'block' : 'hidden'}`}>
                            <div className="p-4">
                                <p className="text-sm text-gray-500 font-semibold mb-3">Reuse Instructions</p>

                                <div className="text-sm text-gray-600 mb-3">
                                    {user.recycleInfo[0].text}
                                </div>

                                <div className="text-sm text-blue-500 underline mb-3">
                                    <a href={user.recycleInfo[0].url} target="_blank" rel="noopener noreferrer">
                                        {user.recycleInfo[0].url}
                                    </a>
                                </div>

                                <div className="flex justify-center">
                                    <img
                                        alt="Recycle Info"
                                        src={user.recycleInfo[0].image}
                                        className="max-w-full h-auto rounded-lg"
                                        style={{
                                            filter: 'invert(1)',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>






                    </div> */}



                    <div className="bg-white rounded-lg shadow-lg relative z-10 mb-2 mt-5">
                        <div className="p-2 cursor-pointer" onClick={() => toggleSection('End of Life')}>
                            <div className="flex justify-between items-center mb-4">
                                <div className="text-base mb-1" style={{ fontSize: '20px' }}>End of Life</div>
                                <svg
                                    className={`w-5 h-5 text-gray-500 transition-transform transform ${expandedSection === 'End of Life' ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>
                        <div className={`transition-all duration-300 overflow-hidden ${expandedSection === 'End of Life' ? 'block' : 'hidden'}`}>
                            <div className="p-4">
                                {/* Reuse Section */}
                                <p className="text-sm text-black font-semibold mb-3 text-left">Reuse Instructions</p>
                                <div className="text-sm text-black mb-3">
                                    {user.reuseInfo[0].text}
                                </div>
                                <div className="mb-4">
                                    <img
                                        alt="Reuse Info"
                                        src={user.reuseInfo[0].image}
                                        className="w-full h-auto rounded-lg"
                                        style={{
                                            filter: 'invert(1)',
                                        }}
                                    />
                                </div>
                                <div className="text-sm text-blue-500 underline mb-6">
                                    <a href={user.reuseInfo[0].url} target="_blank" rel="noopener noreferrer">
                                        {user.reuseInfo[0].url}
                                    </a>
                                </div>

                                {/* Repair Section */}
                                <p className="text-sm text-black font-semibold mb-3 text-left">Repair Instructions</p>
                                <div className="text-sm text-black mb-3">
                                    {user.repairInfo[0].text}
                                </div>
                                <div className="mb-4">
                                    <img
                                        alt="Repair Info"
                                        src={user.repairInfo[0].image}
                                        className="w-full h-auto rounded-lg"
                                        style={{
                                            filter: 'invert(1)',
                                        }}
                                    />
                                </div>
                                <div className="text-sm text-blue-500 underline mb-6">
                                    <a href={user.repairInfo[0].url} target="_blank" rel="noopener noreferrer">
                                        {user.repairInfo[0].url}
                                    </a>
                                </div>

                                {/* Recycle Section */}
                                <p className="text-sm text-black font-semibold mb-3 text-left">Recycle Instructions</p>
                                <div className="text-sm text-black mb-3">
                                    {user.recycleInfo[0].text}
                                </div>
                                <div className="mb-4">
                                    <img
                                        alt="Recycle Info"
                                        src={user.recycleInfo[0].image}
                                        className="w-full h-auto rounded-lg"
                                        style={{
                                            filter: 'invert(1)',
                                        }}
                                    />
                                </div>
                                <div className="text-sm text-blue-500 underline">
                                    <a href={user.recycleInfo[0].url} target="_blank" rel="noopener noreferrer">
                                        {user.recycleInfo[0].url}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="p-1 bg-white rounded-lg shadow-lg relative z-10 mb-1 mt-5">
                        <div className="p-4 flex justify-center">
                            <img
                                alt="Logo"
                                src="/media/logos/enverify2.png"
                                className="app-sidebar-logo-default"
                                style={{
                                    filter: 'invert(1)',
                                    width: '50%',
                                }}
                            />
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
};

export default DdpC;